import { Language } from "../const";

export type PressListData = {
  title: string;
  url: string;
  date: string;
};

export const pressListLanguageMap: Record<Language, string> = {
  [Language.EN]: "/data/en/news-and-videos/press-en.json",
  [Language.TC]: "/data/tc/news-and-videos/press-tc.json",
  [Language.SC]: "/data/sc/news-and-videos/press-sc.json",
};

export function getPressData(press_json: any[]): PressListData[] {
  return press_json?.map((item) => ({
    title: item?.title ?? "",
    url: item?.url ?? "",
    date: item?.date ?? "",
  }));
}
